import { API, GET, PATCH } from '../middleware/api';
import { API_URL } from '../config';

// The per-vehicle settings table (ajoneuvovastaava, toimipiste, vastuukorjaamo)
// of one organization. Rows are keyed by vehicle id.

export function fetchOrganizationVehicleSettings(organizationId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/organization_vehicle_settings/`,
      types: [
        'FETCH_ORGANIZATION_VEHICLE_SETTINGS_REQUEST',
        'FETCH_ORGANIZATION_VEHICLE_SETTINGS_SUCCESS',
        'FETCH_ORGANIZATION_VEHICLE_SETTINGS_FAIL',
      ],
      params: { organization_id: organizationId },
    },
  };
}

// Pick-lists for the table: ajoneuvovastaava candidates, toimipisteet, chain workshops.
export function fetchOrganizationVehicleSettingsChoices(organizationId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/organization_vehicle_settings/choices/`,
      types: [
        'FETCH_ORGANIZATION_VEHICLE_SETTINGS_CHOICES_REQUEST',
        'FETCH_ORGANIZATION_VEHICLE_SETTINGS_CHOICES_SUCCESS',
        'FETCH_ORGANIZATION_VEHICLE_SETTINGS_CHOICES_FAIL',
      ],
      params: { organization_id: organizationId },
    },
  };
}

// `data` is any subset of { responsible_user, business_unit, assigned_workshop }; null clears.
export function updateOrganizationVehicleSettings(vehicleId, data, organizationId) {
  return {
    [API]: {
      method: PATCH,
      url: `${API_URL}/uiapi/1/organization_vehicle_settings/${vehicleId}/`,
      types: [
        'UPDATE_ORGANIZATION_VEHICLE_SETTINGS_REQUEST',
        'UPDATE_ORGANIZATION_VEHICLE_SETTINGS_SUCCESS',
        'UPDATE_ORGANIZATION_VEHICLE_SETTINGS_FAIL',
      ],
      data,
      params: { organization_id: organizationId },
      additionalData: { vehicleId },
    },
  };
}
